export const environment = {
  // URL base
  urlBaseBackoffice: "https://scapad.lyrainnovation.com",
  environmentName: "dev",
  production: true,
};
